


import { defineComponent } from '@vue/composition-api';
import SettouReportCommon from '@/components/Sp/Johaisetsu/SettouPatrol/SettouReportCommon/index.vue';
import CreateSettouOnsiteManagementReport from '@/components/Sp/Johaisetsu/SettouPatrol/SettouOnsiteManagement/CreateSettouOnsiteManagementReport/index.vue';
import StartWorkComponent from '@/components/Sp/Johaisetsu/SettouPatrol/SettouOnsiteManagement/StartWork/index.vue';
import SaveWorkSituation from '@/components/Sp/Johaisetsu/SettouPatrol/SettouOnsiteManagement/SaveWorkSituation/index.vue';
import johaisetsuSettouOnsiteManagementApi from '@/apis/johaisetsu/settouPatrol/settouOnsiteManagement/johaisetsu_settou_onsite_management';
import { JohaisetsuSettouPatrolDetailApi } from '@/components/Sp/Johaisetsu/types';
import {
  updateJohaisetsuStart,
  updateJohaisetsuEnd,
  updateBaseArrival,
} from '@/lib/johaisetsu/settouPatrol/settouOnsiteManagement/johaisetsuSettouOnsiteManagement';

export default defineComponent({
  setup() {
    const detailApis: JohaisetsuSettouPatrolDetailApi = {
      create: johaisetsuSettouOnsiteManagementApi.create,
      update: johaisetsuSettouOnsiteManagementApi.update,
      getCurrent: johaisetsuSettouOnsiteManagementApi.getCurrent,
      updateJohaisetsuStart: updateJohaisetsuStart,
      updateJohaisetsuEnd: updateJohaisetsuEnd,
      updateBaseArrival: updateBaseArrival,
    };

    return {
      detailApis,
      createReportComponent: CreateSettouOnsiteManagementReport,
      startWorkComponent: StartWorkComponent,
      saveWorkSituationComponent: SaveWorkSituation,
    };
  },
  components: { SettouReportCommon },
});
